import { useMutation, useQuery } from "react-query";
import streetLightAPI from "../../services/streetLightAPI";
import { AxiosError } from "axios";
import { StreetLightPatch } from "../../types/streetLight.types";
import { CallbackFunction } from "../../../../common/types/callback.types";


export interface StreetLightCoreConfig {
  planBTId?: string;
}

export default function useStreetLightCore({
  planBTId,
}: StreetLightCoreConfig) {
  const getAllStreetLightsQuery = useQuery({
    queryKey: ["streetLights", planBTId],
    queryFn: () => streetLightAPI.getAllStreetLights(planBTId || ""),
    enabled: planBTId ? true : false,
  });

  const createNewStreetLightMutation = useMutation({
    mutationFn: ({
      streetLight,
      callback,
    }: {
      streetLight: StreetLightPatch;
      callback: CallbackFunction;
    }) =>
      streetLightAPI
        .createNewStreetLight({ ...streetLight })
        .then((res) => {
          callback && callback({ result: res });
        })
        .catch((error) => {
          callback && callback({ error });
        }),
    onSettled: () => {
      getAllStreetLightsQuery.refetch();
    },
  });

  const updateStreetLightMutation = useMutation({
    mutationFn: ({
      streetLightId,
      streetLight,
      callback,
    }: {
      streetLightId: string;
      streetLight: StreetLightPatch;
      callback?: CallbackFunction;
    }) =>
      streetLightAPI
        .updateStreetLight(streetLightId, streetLight)
        .then((res) => {
          callback && callback({ result: res });
          return Promise.resolve(res);
        })
        .catch((error) => {
          callback && callback({ error });
          return Promise.reject(error);
        }),
    onSettled: () => {
      getAllStreetLightsQuery.refetch();
    
    },
  });

  const deleteStreetLightMutation = useMutation({
    mutationFn: ({
      streetLightId,
      callBack,
    }: {
      streetLightId: string;
      callBack?: CallbackFunction;
    }) =>
      streetLightAPI
        .deleteStreetLight(streetLightId)
        .then((res) => {
          callBack && callBack({ result: res });
          return Promise.resolve(res);
        })
        .catch((error) => {
          callBack && callBack({ error });
          return Promise.reject(error);
        }),
    onSettled: () => {
      getAllStreetLightsQuery.refetch();
    },
  });

  return {
    getAllStreetLightsQuery: {
      ...getAllStreetLightsQuery,
      error: getAllStreetLightsQuery.error as AxiosError,
    },
    createNewStreetLightMutation: {
      ...createNewStreetLightMutation,
      error: createNewStreetLightMutation.error as AxiosError,
    },

    updateStreetLightMutation: {
      ...updateStreetLightMutation,
      error: updateStreetLightMutation.error as AxiosError,
    },
    deleteStreetLightMutation: {
      ...deleteStreetLightMutation,
      error: deleteStreetLightMutation.error as AxiosError,
    },
  };
}
